'use client';

import { type useRouter } from 'next/navigation';

import { getAsPath } from '@/hooks/useRouterHistory';

export function goBack(router: ReturnType<typeof useRouter>, url?: string): void {
  const previousPath = getAsPath().prevAsPath;

  if (!previousPath || previousPath === '/callback') {
    if (url) {
      router.replace(url);

      return;
    }

    router.replace('/');

    return;
  }

  router.back();
}
